const customSelectStyle = {
  textField: {
    "& .MuiInputBase-input": {
      fontSize: "16px",
      fontFamily: "'Emeric', Arial, sans-serif",
      fontWeight: 300,
      lineHeight: "1.2",
      color: "#000000",
      padding: "27px 12px 10px",
      border: "1px solid #D9D1C5",
      borderRadius: "4px",
      textTransform: "uppercase",
    },
    "& .MuiInputLabel-root": {
      transform: "translate(12px, 20px) scale(1)",
      zIndex: 1,
      color: "#004571",
      opacity: 0.7,
      marginBottom: "5px",
      transformOrigin: "top left",
      fontSize: "16px",
    },
    "& .MuiFormLabel-root.MuiInputLabel-shrink": {
      transform: "translate(12px, 10px) scale(0.75)",
    },
    "& .MuiFormLabel-root.Mui-focused": {
      color: "#004571",
    },
    "& .MuiFormLabel-root.Mui-disabled": {
      color: "rgba(0, 0, 0, 0.38)",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      display: "none",
    },
    "& .Mui-disabled.MuiInputBase-input": {
      backgroundColor: "rgba(0, 69, 113, 0.08)",
      borderColor: "#D9D1C5",
      color: "rgba(0, 0, 0, 0.38)",
    },
    "& .Mui-focused .MuiInputBase-input": {
      borderColor: "#004b87",
    },
    "@media (max-width: 520px)": {
      maxWidth: "100% !important",
    },
  },

  menuItem: {
    "& .MuiSelect-select": {
      display: "flex",
      alignItems: "flex-end",
    },
    "& .MuiMenu-list": {
      textTransform: "uppercase",
    },
  }
};

export default customSelectStyle;
